import React, {useState, useRef} from 'react'
import {ControlButton} from '../ControlButton'
import IconCheckMark from '@static/images/icon_check.svg'
import IconShare from '@static/images/icon_share.svg'
import {TranslationKeys, TranslationObject} from '@colonist/i18n'
import {T} from '../../../../common/T'

interface ReplayControlsShareButtonProps {
    onShare?: VoidFunction | undefined
    className?: string | undefined
}

export const ReplayControlsShareButton = ({
    onShare,
    className,
}: ReplayControlsShareButtonProps) => {
    const [shareTooltip, setShareTooltip] = useState<TranslationObject | TranslationKeys>('strings:game.tooltips.replay.shareReplay')
    const [shareIcon, setShareIcon] = useState(IconShare)
    const timeoutRef = useRef<NodeJS.Timeout | null>(null)

    const handleShare = () => {
        if(timeoutRef.current) return

        onShare?.()
        setShareTooltip('strings:game.tooltips.replay.copiedLink')
        setShareIcon(IconCheckMark)
        timeoutRef.current = setTimeout(() => {
            setShareTooltip('strings:game.tooltips.replay.shareReplay')
            setShareIcon(IconShare)
            timeoutRef.current = null
        }, 1500)
    }

    return <ControlButton
        icon={shareIcon}
        alt="strings:imgAlts.Share"
        className={className}
        onClick={handleShare}
        tooltipContent={<T id={shareTooltip} />}
    />
}
